export const pilotUsers = [
  "24c8d4f8-e0d1-700b-91fe-340cedc4d1fb",
];

export const canUsePilotFeatures = (userId) =>
  pilotUsers.includes(userId);